<template>
  <div class="container-salespackages">
    <div class="salespackages-pc">
      <Package
        type="side-left"
        :title="packageAmateur.title"
        :subtitle="packageAmateur.subtitle"
        :nummin="packageAmateur.nummin"
        :numvideos="packageAmateur.numvideos"
        :calidad="packageAmateur.calidad"
        :price="!type ? packageAmateur.price : packageAmateur.priceanual"
        :pricedesc="packageAmateur.pricedesc"
        :desc="packageAmateur.desc"
        :isanual="!type"
        @selectplan="selectplan"
      />
      <Package
        type="center"
        :title="packageIdolo.title"
        :subtitle="packageIdolo.subtitle"
        :nummin="packageIdolo.nummin"
        :numvideos="packageIdolo.numvideos"
        :calidad="packageIdolo.calidad"
        :price="!type ? packageIdolo.price : packageIdolo.priceanual"
        :pricedesc="packageIdolo.pricedesc"
        :desc="packageIdolo.desc"
        :isanual="!type"
        @selectplan="selectplan"
      />
      <Package
        type="side-right"
        :title="packageLeyenda.title"
        :subtitle="packageLeyenda.subtitle"
        :nummin="packageLeyenda.nummin"
        :numvideos="packageLeyenda.numvideos"
        :calidad="packageLeyenda.calidad"
        :price="!type ? packageLeyenda.price : packageLeyenda.priceanual"
        :pricedesc="packageLeyenda.pricedesc"
        :desc="packageLeyenda.desc"
        :isanual="!type"
        @selectplan="selectplan"
      />
    </div>
    <div class="salespackages-mobile">
      <div class="menu-packages">
        <div class="menu-packages__item" :class="selected == 0 ? 'active-menu' : ''" @click="selectTypePackege(0)">
          Crack
        </div>
        <div class="menu-packages__item" :class="selected == 1 ? 'active-menu' : ''" @click="selectTypePackege(1)">
          Ídolo
        </div>
        <div class="menu-packages__item" :class="selected == 2 ? 'active-menu' : ''" @click="selectTypePackege(2)">
          Leyenda
        </div>
      </div>
      <BCarousel
        v-model="selected"
        :autoplay="false"
        :pause-info="false"
        :arrow="false"
        :indicator-inside="false"
        @change="changeItemCategory"
      >
        <BCarouselItem>
          <div class="item-slider">
            <div class="flag-package-1"></div>
            <div class="flag-package-2a"><div class="img-popular"></div></div>
            <div class="firts-package">
              <Package
                type="side-left"
                :title="packageAmateur.title"
                :subtitle="packageAmateur.subtitle"
                :nummin="packageAmateur.nummin"
                :numvideos="packageAmateur.numvideos"
                :calidad="packageAmateur.calidad"
                :price="!type ? packageAmateur.price : packageAmateur.priceanual"
                :pricedesc="packageAmateur.pricedesc"
                :desc="packageAmateur.desc"
                :isanual="!type"
                @selectplan="selectplan"
              />
            </div>
          </div>
        </BCarouselItem>
        <BCarouselItem>
          <div class="item-slider">
            <div class="flag-package-1"></div>
            <div class="flag-package-2"></div>
            <div class="firts-package">
              <Package
                type="center"
                :title="packageIdolo.title"
                :subtitle="packageIdolo.subtitle"
                :nummin="packageIdolo.nummin"
                :numvideos="packageIdolo.numvideos"
                :calidad="packageIdolo.calidad"
                :price="!type ? packageIdolo.price : packageIdolo.priceanual"
                :pricedesc="packageIdolo.pricedesc"
                :desc="packageIdolo.desc"
                :isanual="!type"
                @selectplan="selectplan"
              />
            </div>
          </div>
        </BCarouselItem>
        <BCarouselItem>
          <div class="item-slider">
            <div class="flag-package-1a"></div>
            <div class="flag-package-2"></div>
            <div class="firts-package">
              <Package
                type="side-right"
                :title="packageLeyenda.title"
                :subtitle="packageLeyenda.subtitle"
                :nummin="packageLeyenda.nummin"
                :numvideos="packageLeyenda.numvideos"
                :calidad="packageLeyenda.calidad"
                :price="!type ? packageLeyenda.price : packageLeyenda.priceanual"
                :pricedesc="packageLeyenda.pricedesc"
                :desc="packageLeyenda.desc"
                :isanual="!type"
                @selectplan="selectplan"
              />
            </div>
          </div>
        </BCarouselItem>
      </BCarousel>
    </div>
  </div>
</template>
<script>
import { BCarousel, BCarouselItem } from 'buefy/dist/esm/carousel';
export default {
  name: 'SalesPackages',
  props: {
    type: {
      type: Boolean,
      default: false,
    },
  },
  components: { Package: () => import('@/components/Sections/Buy/Package'), BCarousel, BCarouselItem },
  data() {
    return {
      selected: 1,
      packageAmateur: {
        title: 'crack',
        subtitle: 'Para los aficionados casuales',
        nummin: '1,140',
        numvideos: '60',
        calidad: 'baja',
        price: '99',
        priceanual: '1,082',
        pricedesc: '99',
        desc: '50',
      },
      packageIdolo: {
        title: 'ídolo',
        subtitle: 'Para los aficionados casuales',
        nummin: '3,800',
        numvideos: '200',
        calidad: 'media',
        price: '199',
        priceanual: '2,173',
        pricedesc: '2,173',
        desc: '50',
      },
      packageLeyenda: {
        title: 'leyenda',
        subtitle: 'Para los aficionados incondicionales',
        nummin: '24,700',
        numvideos: '1,300',
        calidad: 'alta',
        price: '999',
        priceanual: '10,910',
        pricedesc: '999',
        desc: '50',
      },
    };
  },
  computed: {},
  watch: {},
  methods: {
    selectplan(type) {
      this.$emit('selectplan', type);
      sessionStorage.setItem('typepackageselected', !this.type ? 'mensual' : 'anual');
      if (this.packageAmateur.title == type) {
        sessionStorage.setItem('packageselected', JSON.stringify(this.packageAmateur));
      }
      if (this.packageIdolo.title == type) {
        sessionStorage.setItem('packageselected', JSON.stringify(this.packageIdolo));
      }
      if (this.packageLeyenda.title == type) {
        sessionStorage.setItem('packageselected', JSON.stringify(this.packageLeyenda));
      }
    },
    selectTypePackege(index) {
      this.selected = index;
    },
    changeItemCategory(index) {
      this.selected = index;
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style>
.salespackages-mobile .carousel .carousel-indicator {
  margin-top: -60px;
  position: absolute;
  z-index: 6;
}
@media screen and (max-width: 768px) {
  .salespackages-mobile .carousel .carousel-indicator {
    margin-top: -182px;
  }
}
@media screen and (max-width: 480px) {
  .salespackages-mobile .carousel .carousel-indicator {
    margin-top: -235px;
  }
}
.salespackages-mobile .carousel .carousel-indicator .indicator-item .indicator-style {
  width: 20px;
  height: 4px;
  border-radius: 2px;
  background-color: #c0c0c0c7;
  border: none;
}
.salespackages-mobile .carousel .carousel-indicator .indicator-item:not(:last-child) {
  margin-right: 0.1rem;
}
.salespackages-mobile .carousel .carousel-indicator .indicator-item .indicator-style:hover {
  background: rgb(203, 238, 106) !important;
}
.salespackages-mobile .carousel .carousel-indicator .indicator-item.is-active .indicator-style {
  background: rgb(203, 238, 106) !important;
}
.salespackages-mobile .carousel .carousel-indicator.is-inside.is-bottom {
  bottom: -3px;
}
@media screen and (max-width: 610px) {
  .salespackages-mobile .carousel .carousel-indicator.is-inside.is-bottom {
    bottom: 35px;
  }
}
@media screen and (max-width: 400px) {
  .salespackages-mobile .carousel .carousel-indicator.is-inside.is-bottom {
    bottom: 40px;
  }
}
@media screen and (max-width: 360px) {
  .salespackages-mobile .carousel .carousel-indicator.is-inside.is-bottom {
    bottom: 24px;
  }
}
.salespackages-mobile .carousel-arrow .icon.has-icons-right {
  display: none;
}
.salespackages-mobile .carousel-arrow .icon.has-icons-left {
  display: none;
}
.is-fullheight-with-navbar-and-footer,
.is-fullheight-with-navbar-and-footer-mobile {
  height: 100%;
}
</style>
<style lang="scss" scoped>
.img-popular {
  width: 80px;
  height: 80px;
  position: absolute;
  background-image: url('/images/banda_popular.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  right: 0;
}
.flag-package-1 {
  position: absolute;
  // background: purple;
  width: 70%;
  height: 600px;
  z-index: 1;
  margin-left: 0px;
  border-radius: 24px;
  box-shadow: 20px 30px 60px 0 rgba(22, 29, 46, 0.24);
  background-color: #fff;
  @media screen and (max-width: 460px) {
    height: 543px;
  }
}
.flag-package-1a {
  position: absolute;
  // background: purple;
  width: 70%;
  height: 600px;
  z-index: 1;
  margin-left: 0px;
  border-radius: 24px;
  box-shadow: 20px 30px 60px 0 rgba(22, 29, 46, 0.24);
  background-color: #132839;
  @media screen and (max-width: 460px) {
    height: 543px;
  }
}
.flag-package-2 {
  position: absolute;
  width: 70%;
  height: 600px;
  z-index: 2;
  right: 0;
  margin-right: 0px;
  border-radius: 24px;
  box-shadow: 20px 30px 60px 0 rgba(22, 29, 46, 0.24);
  background-color: #fff;
  @media screen and (max-width: 460px) {
    height: 543px;
  }
}
.flag-package-2a {
  position: absolute;
  width: 70%;
  height: 600px;
  z-index: 2;
  right: 0;
  margin-right: 0px;
  border-radius: 24px;
  box-shadow: 20px 30px 60px 0 rgba(22, 29, 46, 0.24);
  background-color: #132839;
  @media screen and (max-width: 460px) {
    height: 543px;
  }
}
.firts-package {
  position: absolute;
  width: 715px;
  height: 600px;
  z-index: 3;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  @media screen and (max-width: 915px) {
    width: 100%;
  }
  @media screen and (max-width: 460px) {
    height: 543px;
  }
}
.item-slider {
  width: 795px;
  height: 720px;
  position: relative;
  @media screen and (max-width: 815px) {
    width: 748px;
  }
  @media screen and (max-width: 768px) {
    width: 708px;
  }
  @media screen and (max-width: 715px) {
    width: 100% !important;
    display: inline-block;
    max-width: 680px;
  }
}
.container-salespackages {
  width: 100%;
  height: 600px;
  @media screen and (max-width: 768px) {
    margin-top: 16px;
  }
}
.salespackages-pc {
  width: 100%;
  height: 600px;
  margin-top: 10px;
  display: inline-flex;
  @media screen and (max-width: 768px) {
    display: none;
  }
}
.salespackages-mobile {
  display: none;
  @media screen and (max-width: 768px) {
    display: inline-block;
  }
  @media screen and (max-width: 715px) {
    max-width: 680px;
    width: 100%;
  }
}
.menu-packages {
  width: 93%;
  height: 36px;
  padding: 3px;
  border-radius: 50px;
  border: solid 1px #132839;
  margin: 0 auto;
  margin-bottom: 20px;
  margin-top: 16px;
  display: inline-flex;
  justify-content: space-between;

  &__item {
    width: 33%;
    height: 28px;

    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 28px;
    letter-spacing: normal;
    text-align: center;
    color: #132839;
    font-family: 'Avenir-Medium';
    border-radius: 30px;
  }
}
.active-menu {
  background: #132839;
  color: white;
}
</style>
